// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../styles/fonts/SFUIDisplay-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../styles/fonts/SFUIDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../styles/fonts/SFUIDisplay-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../styles/fonts/SFUIDisplay-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/fonts/SFUIDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../styles/fonts/SFUIDisplay-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../styles/fonts/SFUIDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../styles/fonts/SFUIDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../styles/fonts/SFUIDisplay-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../styles/fonts/SFUIDisplay-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../styles/fonts/SFUIDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../styles/fonts/SFUIDisplay-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../styles/fonts/SFUIDisplayRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../styles/fonts/SFUIDisplayRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../styles/fonts/SFUIDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../styles/fonts/SFUIDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../styles/fonts/SFUIDisplay-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#svgFontName" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SFUIDisplay-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg"); /* Legacy iOS */
}
.viewUser_dashboard__iThb1 {
  width: calc(100% - 200px);
  position: relative;
  left: 200px;
  padding: 20px;
}

.viewUser_cont2__-kuqZ {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 20px;
}

body {
  background-color: #f3f6f9;
}

.viewUser_bodythemelight__0PGJc {
  background-color: #f3f6f9;
}

.viewUser_bodythemedark__wulnI {
  background-color: #151521;
}

.viewUser_headerthemelight__SlKj2 {
  background-color: #fff;
}

.viewUser_headerthemedark__NMtco {
  background-color: #151521;
}

.viewUser_menuthemelight__V31yz {
  background-color: #fff;
}

.viewUser_menuthemedark__YSvyO {
  background-color: #151521;
}

.viewUser_menulinklight__TMqfU {
  color: #60677e !important;
}

.viewUser_menulinklightSelected__jqaxe {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.viewUser_menulinkdarkSelected__QX0Vz {
  color: #fff !important;
  border-radius: 10px;
}

.viewUser_menulinkdark__rBWoe {
  color: #60677e !important;
}

.viewUser_menulinklight__TMqfU:hover {
  color: #1d1d1d !important;
}

.viewUser_menulinkdark__rBWoe:hover {
  color: #fff !important;
}

.viewUser_headinglight__3ordU {
  color: #60677e;
}

.viewUser_headingdark__YUOnG {
  color: #60677e;
}

.viewUser_searchboxlight__lT-JP {
  background-color: #fff;
  border: none;
}

.viewUser_searchboxdark__IaMcG {
  background-color: #1e1e2d;
  color: #60677e;
}

.viewUser_searchboxdark__IaMcG::placeholder {
  color: #60677e;
}

.viewUser_tableheadlight__ucFTs {
  background-color: #e9eaf0;
}

.viewUser_tableheaddark__U9m4X {
  background-color: #1e1e2d;
  color: #60677e;
}

.viewUser_tablebodylight__kEXJa {
  background-color: #fff;
}
.viewUser_tablebodylight__kEXJa:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.viewUser_tablebodydark__aRWdM {
  background-color: #1e1e2d;
  color: #60677e;
}
.viewUser_tablebodydark__aRWdM:hover {
  background-color: #252530;
  cursor: pointer;
}

.viewUser_paginationlight__0df3c {
  color: #60677e !important;
  font-size: 13px !important;
}

.viewUser_paginationdark__2SShC {
  color: #60677e !important;
  font-size: 13px !important;
}

.viewUser_formthemelight__l7JgF {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.viewUser_formthemedark__O6Pbp {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.viewUser_formthemedark__O6Pbp ::placeholder {
  color: #60677e;
}

.viewUser_viewformlight__fWN3w {
  background-color: #f3f6f9;
}

.viewUser_viewformdark__iqK9n {
  background-color: #151521;
}

.viewUser_permissionboxlight__g2Jzw {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.viewUser_permissionboxdark__u5Qv4 {
  background-color: #151521;
  border: none;
}

.viewUser_errormsgclr__c9\\+6D {
  color: red;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-top: 5px;
}

.viewUser_graphclrlight__qXmCC {
  background-color: #fff;
}

.viewUser_graphclrdark__0JXBj {
  background-color: #1e1e2d;
}

#viewUser_card1bglight__5BhlI {
  background: linear-gradient(90deg, rgb(181, 219, 177) 13%, rgb(125, 178, 144) 100%);
}

#viewUser_card1bgdark__NLxYm {
  background: #392f28;
}

#viewUser_card2bglight__zKXly {
  background: linear-gradient(90deg, rgb(243, 198, 165) 0%, rgb(248, 163, 168) 100%);
}

#viewUser_card2bgdark__UDFQ\\+ {
  background: #1c3238;
}

#viewUser_card3bglight__ivWjs {
  background: linear-gradient(90deg, rgb(213, 149, 211) 0%, rgb(174, 132, 192) 100%);
}

#viewUser_card3bgdark__qWBhh {
  background: #3a2434;
}

#viewUser_card4bglight__ThLGp {
  background: linear-gradient(90deg, rgb(140, 212, 214) 0%, rgb(150, 202, 247) 100%);
}

#viewUser_card4bgdark__fZIls {
  background: #2f264f;
}

.viewUser_actionbtnlight__XcYy0 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.viewUser_actionbtndark__s2vFY {
  color: #60677e;
}

.viewUser_profiledropdownlight__LuxDl {
  background-color: #fff;
}

.viewUser_profiledropdowndark__WGyp9 {
  background-color: #151521;
}

@media only screen and (max-width: 600px) {
  .viewUser_cont2__-kuqZ {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px !important;
  }
}
#viewUser_addform__sOr4v {
  width: 100%;
  padding: 10px 10px 20px 10px;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 20px;
}
#viewUser_addform__sOr4v #viewUser_addheading__vGTQP {
  font-size: 18px;
  font-family: "SFUIDisplayRegular";
  margin-left: 10px;
}
#viewUser_addform__sOr4v .viewUser_profilepicdiv__DW1M2 {
  padding: 10px;
  border-radius: 5px;
}
#viewUser_addform__sOr4v .viewUser_profilepic__PAI2d {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid rgba(33, 37, 41, 0.4588235294);
  padding: 5px;
}
#viewUser_addform__sOr4v .viewUser_namesection__oFNuW {
  display: inline-block;
}
#viewUser_addform__sOr4v .viewUser_profilename__1y1cK {
  font-size: 16px;
  font-family: "SFUIDisplay-Medium";
  margin-left: 20px;
  margin-top: 30px;
}
#viewUser_addform__sOr4v .viewUser_profileemail__zoh\\+F {
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-left: 20px;
}
#viewUser_addform__sOr4v #viewUser_empdiv__cOJ0m {
  padding: 5px 0px 0px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
  height: 55px;
}
#viewUser_addform__sOr4v #viewUser_empdiv__cOJ0m .viewUser_title__NZ-pF {
  font-family: "SFUIDisplayRegular";
  font-size: 13px;
}
#viewUser_addform__sOr4v #viewUser_empdiv__cOJ0m .viewUser_empname__wUtTf {
  font-family: "SFUIDisplay-Medium";
  font-size: 14px;
}
#viewUser_addform__sOr4v .viewUser_arrowback__C5ITR {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#viewUser_addform__sOr4v .viewUser_arrowback__C5ITR:hover {
  background-color: #39979d;
  color: #fff;
}

@media only screen and (max-width: 600px) {
  #viewUser_dashboardcont2__nCgwF {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/viewUser.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA,EAAA,qBAAA;EACA,4SAAA,EAI8F,eAAA;ACHhG;ADMA;EACE,+BAAA;EACA,4CAAA,EAAA,qBAAA;EACA,8SAAA,EAI6F,eAAA;ACR/F;ADUA;EACE,gCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI8F,eAAA;ACZhG;ADeA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI+F,eAAA;ACjBjG;ADmBA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIoF,eAAA;ACrBtF;ADuBA;EACE,mCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIiG,eAAA;ACzBnG;ADiEA;EACE,yBAbe;EAcf,kBAAA;EACA,WAbc;EAcd,aAbiB;AClDnB;;ADqEA;EACE,wBAhBU;EAiBV,UAhBS;EAiBT,kBAAA;EACA,aAvBiB;AC3CnB;;ADuEA;EACE,yBAtDgB;ACdlB;;ADwEA;EACE,yBA3DgB;ACVlB;;ADuEA;EACE,yBA7De;ACPjB;;ADwEA;EACE,sBAhEY;ACLd;;ADwEA;EACE,yBAtEe;ACCjB;;ADyEA;EACE,sBAzEY;ACGd;;ADwEA;EACE,yBA9Ee;ACSjB;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EAEE,yBAAA;EACA,mBAAA;ACvEF;;ADyEA;EAEE,sBAAA;EACA,mBAAA;ACvEF;;AD0EA;EACE,yBAAA;ACvEF;;AD0EA;EAEE,yBAAA;ACxEF;;AD0EA;EAEE,sBAAA;ACxEF;;AD4EA;EACE,cA5Ge;ACmCjB;;AD4EA;EACE,cAhHe;ACuCjB;;AD6EA;EACE,sBAvHY;EAwHZ,YAAA;AC1EF;;AD6EA;EACE,yBAvHkB;EAwHlB,cA3He;ACiDjB;;AD4EA;EACE,cA9He;ACqDjB;;AD6EA;EACE,yBA1HiB;ACgDnB;;AD4EA;EACE,yBAnIkB;EAoIlB,cAvIe;AC8DjB;;AD4EA;EACE,sBA7IY;ACoEd;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD4EA;EACE,yBAhJkB;EAiJlB,cApJe;AC2EjB;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD8EA;EACE,yBAAA;EACA,0BAAA;AC3EF;;AD6EA;EACE,yBAAA;EACA,0BAAA;AC1EF;;AD8EA;EACE,sBA1KY;EA2KZ,yBAAA;EACA,qDAAA;AC3EF;;AD6EA;EACE,yBA1KkB;EA2KlB,yBAAA;EACA,eAAA;AC1EF;AD4EE;EACE,cAlLa;ACwGjB;;ADgFA;EACE,yBA9LgB;ACiHlB;;AD+EA;EACE,yBAhMe;ACoHjB;;AD+EA;EACE,yBAAA;EACA,yBAAA;AC5EF;;AD8EA;EACE,yBAAA;EACA,YAAA;AC3EF;;AD8EA;EACE,UAAA;EACA,eAAA;EACA,iCA9Le;EA+Lf,eAAA;AC3EF;;AD+EA;EACE,sBAnNY;ACuId;;AD+EA;EACE,yBAlNkB;ACsIpB;;ADgFA;EACE,mFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADkFA;EACE,qCAAA;AC/EF;;ADkFA;EACE,cAhQe;ACiLjB;;ADoFA;EACE,sBAAA;ACjFF;;ADoFA;EACE,yBAAA;ACjFF;;ADoFA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClFF;AACF;AAhQA;EACI,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAkQJ;AAhQI;EACI,eAAA;EACA,iCDkES;ECjET,iBAAA;AAkQR;AA/PI;EACI,aAAA;EACA,kBAAA;AAiQR;AA9PI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gDAAA;EACA,YAAA;AAgQR;AA9PI;EACI,qBAAA;AAgQR;AA7PI;EACI,eAAA;EACA,iCD2CQ;EC1CR,iBAAA;EACA,gBAAA;AA+PR;AA7PI;EACI,eAAA;EACA,iCDsCS;ECrCT,iBAAA;AA+PR;AA1PQ;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AA4PZ;AA1PY;EACI,iCDyBC;ECxBD,eAAA;AA4PhB;AAzPY;EACI,iCDmBA;EClBA,eAAA;AA2PhB;AArPQ;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAuPZ;AArPc;EACE,yBAAA;EACA,WAAA;AAuPhB;;AA/OA;EACI;IACI,wBDII;ICHJ,UDIG;ICHH,kBAAA;IACA,aDHW;ECqPjB;AACF","sourcesContent":["@font-face {\n  font-family: 'SFUIDisplay-Black';\n  src: url('../fonts/SFUIDisplay-Black.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Black.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Black.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Black.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Black.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Black.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Bold';\n  src: url('../fonts/SFUIDisplay-Bold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Bold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Bold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Bold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Bold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Light';\n  src: url('../fonts/SFUIDisplay-Light.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Light.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Light.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Light.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Light.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Light.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Medium';\n  src: url('../fonts/SFUIDisplay-Medium.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Medium.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Medium.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Medium.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Medium.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Medium.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplayRegular';\n  src: url('../fonts/SFUIDisplayRegular.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplayRegular.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplayRegular.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Regular.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Regular.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Regular.svg') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Semibold';\n  src: url('../fonts/SFUIDisplay-Semibold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Semibold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Semibold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n//scss//\n\n//Body Theme Color\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n//Dark Theme Colors\n$primarydark-color: #1e1e2d;\n\n//Button Theme\n$primary-btncolor: #39979d;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n$sffont-bold: 'SFUIDisplay-Bold';\n$sffont-medium: 'SFUIDisplay-Medium';\n$sffont-regular: 'SFUIDisplayRegular';\n\n//Max Dashboard scss//\n\n$dashboardwidth: calc(100% - 200px);\n$dashboardposition: absolute;\n$dashboardleft: 200px;\n$dashboardpadding: 20px;\n\n//Min Dashboard scss//\n\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n//Max Dashboard scss//\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n}\n\n//Min Dashboard scss//\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n  // padding-bottom: 8%;\n}\n\nbody {\n  background-color: $lightthemecolor;\n}\n\n//THEME CHANGE\n.bodythemelight {\n  background-color: $lightthemecolor;\n}\n.bodythemedark {\n  background-color: $darkthemecolor;\n}\n\n//Header Navbar Theme\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU THEME CHANGE\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU LINKS THEME CHANGE\n.menulinklight {\n  color: $lightthemetext !important;\n}\n\n.menulinklightSelected {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n.menulinkdarkSelected {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n}\n.menulinkdark:hover {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n}\n\n//BODY HEADERS\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n//SEARCH BOX THEME COLOR\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n//CUSTOM TABLE THEME COLOR\n.tableheadlight {\n  background-color: $tableheadlightbg;\n}\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: #252530;\n    cursor: pointer;\n  }\n}\n\n//PAGINATION THEME COLOR\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n//SETTING FORM THEME COLOR\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n//VIEW FORM DETAILS BOX THEME COLOR\n\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n.viewformdark {\n  background-color: $darkthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: none;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  font-family: $sffont-regular;\n  margin-top: 5px;\n}\n\n//Graph theme\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n//Counter theme\n#card1bglight {\n  background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%);\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%);\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%);\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%);\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n//Action button theme\n\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n//profile dropdowntheme\n\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n@media only screen and (max-width: 600px) {\n\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: $dashboardpadding !important;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n    width: 100%;\n    padding: 10px 10px 20px 10px;\n    border-radius: 5px;\n    margin-top: 30px;\n    margin-bottom: 20px;\n   \n    #addheading{\n        font-size: 18px;\n        font-family: $sffont-regular;\n        margin-left: 10px;\n    }\n\n    .profilepicdiv{\n        padding: 10px;\n        border-radius: 5px;\n    }\n\n    .profilepic{\n        width: 100px;\n        height: 100px;\n        border-radius: 50%;\n        border: 1px solid #21252975;\n        padding: 5px;\n    }\n    .namesection{\n        display: inline-block;\n    }\n\n    .profilename{\n        font-size: 16px;\n        font-family: $sffont-medium;\n        margin-left: 20px;\n        margin-top: 30px;\n    }\n    .profileemail{\n        font-size: 14px;\n        font-family: $sffont-regular;\n        margin-left: 20px;\n    }\n   \n\n\n        #empdiv{\n            padding:5px 0px 0px 15px;\n            margin-bottom: 10px;\n            border-radius: 5px;\n            height: 55px;\n\n            .title{\n                font-family: $sffont-regular;\n                font-size: 13px;\n            }\n\n            .empname{\n                font-family: $sffont-medium;\n                font-size: 14px;\n                // padding-bottom:8px;\n            }\n        }\n\n        \n        .arrowback{\n            float: right;\n            background-color: #dde2eb;\n            padding: 10px;\n            color: #39979d;\n            cursor: pointer;\n            border-radius: 3px;\n    \n              &:hover{\n                background-color: #39979d;\n                color: #fff;\n              }\n          }\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `viewUser_dashboard__iThb1`,
	"cont2": `viewUser_cont2__-kuqZ`,
	"bodythemelight": `viewUser_bodythemelight__0PGJc`,
	"bodythemedark": `viewUser_bodythemedark__wulnI`,
	"headerthemelight": `viewUser_headerthemelight__SlKj2`,
	"headerthemedark": `viewUser_headerthemedark__NMtco`,
	"menuthemelight": `viewUser_menuthemelight__V31yz`,
	"menuthemedark": `viewUser_menuthemedark__YSvyO`,
	"menulinklight": `viewUser_menulinklight__TMqfU`,
	"menulinklightSelected": `viewUser_menulinklightSelected__jqaxe`,
	"menulinkdarkSelected": `viewUser_menulinkdarkSelected__QX0Vz`,
	"menulinkdark": `viewUser_menulinkdark__rBWoe`,
	"headinglight": `viewUser_headinglight__3ordU`,
	"headingdark": `viewUser_headingdark__YUOnG`,
	"searchboxlight": `viewUser_searchboxlight__lT-JP`,
	"searchboxdark": `viewUser_searchboxdark__IaMcG`,
	"tableheadlight": `viewUser_tableheadlight__ucFTs`,
	"tableheaddark": `viewUser_tableheaddark__U9m4X`,
	"tablebodylight": `viewUser_tablebodylight__kEXJa`,
	"tablebodydark": `viewUser_tablebodydark__aRWdM`,
	"paginationlight": `viewUser_paginationlight__0df3c`,
	"paginationdark": `viewUser_paginationdark__2SShC`,
	"formthemelight": `viewUser_formthemelight__l7JgF`,
	"formthemedark": `viewUser_formthemedark__O6Pbp`,
	"viewformlight": `viewUser_viewformlight__fWN3w`,
	"viewformdark": `viewUser_viewformdark__iqK9n`,
	"permissionboxlight": `viewUser_permissionboxlight__g2Jzw`,
	"permissionboxdark": `viewUser_permissionboxdark__u5Qv4`,
	"errormsgclr": `viewUser_errormsgclr__c9+6D`,
	"graphclrlight": `viewUser_graphclrlight__qXmCC`,
	"graphclrdark": `viewUser_graphclrdark__0JXBj`,
	"card1bglight": `viewUser_card1bglight__5BhlI`,
	"card1bgdark": `viewUser_card1bgdark__NLxYm`,
	"card2bglight": `viewUser_card2bglight__zKXly`,
	"card2bgdark": `viewUser_card2bgdark__UDFQ+`,
	"card3bglight": `viewUser_card3bglight__ivWjs`,
	"card3bgdark": `viewUser_card3bgdark__qWBhh`,
	"card4bglight": `viewUser_card4bglight__ThLGp`,
	"card4bgdark": `viewUser_card4bgdark__fZIls`,
	"actionbtnlight": `viewUser_actionbtnlight__XcYy0`,
	"actionbtndark": `viewUser_actionbtndark__s2vFY`,
	"profiledropdownlight": `viewUser_profiledropdownlight__LuxDl`,
	"profiledropdowndark": `viewUser_profiledropdowndark__WGyp9`,
	"addform": `viewUser_addform__sOr4v`,
	"addheading": `viewUser_addheading__vGTQP`,
	"profilepicdiv": `viewUser_profilepicdiv__DW1M2`,
	"profilepic": `viewUser_profilepic__PAI2d`,
	"namesection": `viewUser_namesection__oFNuW`,
	"profilename": `viewUser_profilename__1y1cK`,
	"profileemail": `viewUser_profileemail__zoh+F`,
	"empdiv": `viewUser_empdiv__cOJ0m`,
	"title": `viewUser_title__NZ-pF`,
	"empname": `viewUser_empname__wUtTf`,
	"arrowback": `viewUser_arrowback__C5ITR`,
	"dashboardcont2": `viewUser_dashboardcont2__nCgwF`
};
export default ___CSS_LOADER_EXPORT___;
